/* tslint:disable */
/* eslint-disable */

/**
 * profile
 */
export enum Profile {
  Admin = 'ADMIN',
  Uploader = 'UPLOADER',
  Engineer = 'ENGINEER',
  Viewer = 'VIEWER'
}
